import type { IPerson } from '../../domain';
import { ApiBaseService } from '../api-base-service';

export class CustomerMasterDataApiService extends ApiBaseService {
    constructor(context = '/delegate/customer-master-data') {
        super(`${context}/v4`);
    }

    async fetchOwnerOnlyPerson(): Promise<IPerson[]> {
        return this.http.get<IPerson[]>('/persons', { params: { 'owner-only': true } }).then((response) => response.data);
    }
}
